// src/components/Common/header/CurrencySwitcher.jsx
// Small £ / $ toggle for the navigation bar. Hidden when US sales are switched off.
import React from 'react';
import { useCurrency } from '../../../context/CurrencyContext';

const options = [
    { code: 'GBP', label: '£ GBP', title: 'Prices in pounds, shipping to the UK' },
    { code: 'USD', label: '$ USD', title: 'Prices in US dollars, shipping to the USA' },
];

const CurrencySwitcher = ({ style }) => {
    const { currency, setCurrency, usAvailable } = useCurrency();
    if (!usAvailable) return null;

    return (
        <div
            role="group"
            aria-label="Choose currency"
            style={{
                display: 'inline-flex',
                border: '1px solid rgba(212, 175, 55, 0.4)',
                borderRadius: '2px',
                overflow: 'hidden',
                fontFamily: "'Montserrat', sans-serif",
                ...style,
            }}
        >
            {options.map(opt => {
                const active = currency === opt.code;
                return (
                    <button
                        key={opt.code}
                        type="button"
                        title={opt.title}
                        aria-pressed={active}
                        onClick={() => setCurrency(opt.code)}
                        style={{
                            background: active ? '#d4af37' : 'transparent',
                            color: active ? '#000' : '#d4af37',
                            border: 'none',
                            padding: '6px 12px',
                            fontSize: '0.7rem',
                            fontWeight: 700,
                            letterSpacing: '1.5px',
                            cursor: 'pointer',
                            transition: 'background 0.2s, color 0.2s',
                        }}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
};

export default CurrencySwitcher;